import VuexStore from '../store';

import {serverBus} from '../main'

const Helper = {
    install(Vue) {

        Vue.mixin({
            /* mounted() {
                console.log('Mounted!');
            },*/
        });

        Vue.prototype.$getColors = function () {
            return ['rgb(160, 54, 30)', 'rgb(167, 141, 70)', 'rgb(5, 131, 152)', 'rgb(86, 86, 84)', 'rgb(39, 130, 58)', 'rgb(93, 60, 130)'];
        };

        Vue.prototype.$randomizeColor = function () {
            let colors = this.$getColors();
            let random = parseInt(Math.random() * colors.length);

            return colors[random];
        };

        Vue.prototype.$getUser = function () {
            return VuexStore.state.user;
        };

        Vue.prototype.$getTable = function () {
            return VuexStore.state.table;
        };

        Vue.prototype.$getData = function () {
            return VuexStore.state.data;
        };

        Vue.prototype.$navigate = function (path) {
            let self = this;

            setTimeout(function () {
                self.$router.push(path);
            }, 20);
        };

        Vue.prototype.$useDialog = function () {
            return VuexStore.state.editInDialog;
        };

        Vue.prototype.$formatPrice = function (value) {
            let formatter = new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            return formatter.format(value);
        };

        Vue.prototype.$formatQuantity = function (value) {
            let formatter = new Intl.NumberFormat('de-DE', {
                maximumFractionDigits: 0
            });

            return formatter.format(value);
        };

        Vue.prototype.$checkPermission = function (permission) {
            if (permission === 'for everyone') {
                return true;
            }

            for (let i = 0; i < VuexStore.state.permissions.length; i++) {
                if (VuexStore.state.permissions[i] === permission) {
                    return true;
                }
            }

            return false;
        };

        Vue.prototype.$checkAllPermissions = function (permissions) {

            for (let i = 0; i < permissions.length; i++) {
                let any = false;

                for (let j = 0; j < VuexStore.state.permissions.length; j++) {
                    if (permissions[i] === VuexStore.state.permissions[i]) {
                        any = true;
                        break;
                    }
                }

                if (any === false) {
                    return false;
                }
            }

            return true;
        };

        Vue.prototype.$checkAnyOfPermissions = function (permissions) {

            for (let i = 0; i < permissions.length; i++) {
                for (let j = 0; j < VuexStore.state.permissions.length; j++) {
                    if (permissions[i] === VuexStore.state.permissions[i]) {
                        return true;
                    }
                }
            }

            return true;
        };

        Vue.prototype.$parseDate = function (date) {
            if (!date) return null;

            const [year, month, day] = date.split('-');
            return `${day}.${month}.${year}`
        };

        Vue.prototype.$todayDate = function () {
            const weekDays = ['Nedjelja', 'Ponedjeljak', 'Utorak', 
                'Srijeda', 'Četvrtak', 'Petak', 'Subota'];

            let dateObj = new Date();
            
            let month = dateObj.getMonth() + 1;
            let day = String(dateObj.getDate()).padStart(1, '0');
            let year = dateObj.getFullYear();
            let weekDay = weekDays[ dateObj.getDay() ];
            let output = `${weekDay}, ${day}.${month}.${year}.`

            return output
        };
        // Vue.prototype.$currentTime = function () {
        //
        //     let time = new Date();
        //
        //     let hour = time.getHours();
        //     let minute = time.getMinutes();
        //     let seconds = time.getSeconds();
        //
        //     let output = `${hour}:${minute}:${seconds}`
        //     console.log(output);
        //     return output
        // };

        Vue.prototype.$clearNumber = function (number) {
            number = number + "";
            return number.toString().replace(/[^0-9.]/, '');
        };


        Vue.prototype.$destroyEvents = function () {
            let events = [
                'reload-table-data', 'filters-changed', 'perform-search',
            ];

            for (let i = 0; i < events.length; i++) {
                let event = events[i];
                serverBus.$off(event);
            }

            return false;
        };

    }
};

export default Helper;
